import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0ebe2c8a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "cs-container" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"error-page\" data-v-0ebe2c8a><div class=\"error-page__container text-center\" data-v-0ebe2c8a><h1 class=\"error-page__title\" data-v-0ebe2c8a>페이지를 찾을 수 없습니다.</h1><p class=\"error-page__desc mt-2\" data-v-0ebe2c8a> 링크를 클릭하여 시작 페이지로 이동합니다. <a class=\"error-page__link underline ml-2\" href=\"/client/estimate\" data-v-0ebe2c8a>이동하기</a></p></div></div>", 1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
}